{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Veidnes",
    "DESCRIPTION": "Skatiet ziņojumu veidnes, kas sinhronizētas no jūsu WhatsApp iesūtnēm. Lai izveidotu vai rediģētu veidni, pārvaldiet to pie sava pakalpojumu sniedzēja.",
    "COUNT": "Veidnes: {n}",
    "LEARN_MORE": "Uzzināt vairāk par WhatsApp veidnēm",
    "SYNC_TEMPLATES": "Sinhronizēt veidnes",
    "SYNC_SUCCESS": "Veidņu sinhronizācija sākta visām WhatsApp iesūtnēm. Izmaiņas var parādīties pēc dažām minūtēm.",
    "PARTIAL_SYNC_ERROR": "Veidņu sinhronizācija sākta dažām WhatsApp iesūtnēm, bet citas neizdevās sinhronizēt.",
    "SYNC_ERROR": "Neizdevās sākt veidņu sinhronizāciju. Lūdzu, mēģiniet vēlreiz.",
    "SEARCH_PLACEHOLDER": "Meklēt pēc satura vai nosaukuma...",
    "MANAGE_IN_META": "Pārvaldīt Meta",
    "LOADING": "Notiek WhatsApp veidņu ielāde...",
    "EMPTY": "WhatsApp veidnes nav atrastas.",
    "NO_RESULTS": "Neviena veidne neatbilst jūsu filtriem.",
    "FETCH_ERROR": "Neizdevās ielādēt WhatsApp veidnes. Lūdzu, mēģiniet vēlreiz.",
    "PARTIAL_FETCH_ERROR": "Dažas WhatsApp veidnes neizdevās ielādēt. Lūdzu, mēģiniet vēlreiz.",
    "LAST_SYNC_ATTEMPT": "Pēdējais sinhronizācijas mēģinājums {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Nav iesniegts WhatsApp apstiprināšanai"
    },
    "FILTERS": {
      "ALL_INBOXES": "Visas iesūtnes",
      "ALL_LANGUAGES": "Visas valodas",
      "ALL_TYPES": "Visi veidi"
    },
    "TYPES": {
      "TEXT": "Teksts",
      "IMAGE": "Attēls",
      "VIDEO": "Video",
      "DOCUMENT": "Dokuments",
      "CALL_TO_ACTION": "Aicinājums uz darbību",
      "COPY_CODE": "Kopēt kodu"
    },
    "PREVIEW": {
      "TITLE": "Veidnes priekšskatījums",
      "DESCRIPTION": "Priekšskatiet, kā šī veidne izskatās WhatsApp.",
      "OPEN": "Priekšskatīt {name}",
      "CLOSE": "Aizvērt priekšskatījumu",
      "DETAILS": "Veidnes informācija",
      "STATUS": "Statuss",
      "TYPE": "Satura veids",
      "CATEGORY": "Kategorija",
      "LANGUAGE": "Valoda",
      "INBOXES": "Iesūtnes"
    }
  }
}
